export default {
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    phone: /^([0-9\(\)\/\+ \-]*)$/,
    text: /^'*[a-zA-Z\s][a-zA-Z'\s]*$/,
    url: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
    twoDecimal: /^\d+(\.\d{1,2})?$/,
    ipAddress: /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/constants/regexp.constant.js